<span class="xp-info-row__label">{{ label() }}</span>
<span class="xp-info-row__value"><ng-content></ng-content></span>
